// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wp_a bik_b"};